import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";

import { SoundEnum } from "src/app/enums/sound.enum";
import { IConfirm } from "src/app/interfaces/confirm";
import { IHolding } from "src/app/interfaces/holding";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { HoldingEntryComponent } from "./holding-entry/holding-entry.component";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import {
  MatSort,
  MatTableDataSource,
  MatDialog,
  MatPaginator
} from "@angular/material";

@Component({
  selector: "app-holding",
  templateUrl: "./holding.component.html",
  styleUrls: ["./holding.component.css"]
  // providers: [ErrorsService]
})
export class HoldingComponent implements OnInit {
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ["title", "function"];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  data: any;
  errors: any;
  param: any;

  constructor(
    private holdingService: HoldingService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.list();
    this.dataSource.sort = this.sort;
  }

  list() {
    this.holdingService.list().subscribe(
      res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
        // this.paginator.pageIndex = 0;
        // this.paginator.pageSize = 10;
      },
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("error.listShow", {
            name: this.translate.get("label.holding")
          }),
          "OK",
          5000,
          SoundEnum.beep
        );
      }
    );
  }

  paginatorEvent(_event) {
    this.holdingService
      .list()
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  add(): void {
    const dialogRef = this.dialog.open(HoldingEntryComponent, {
      width: "350px"
    });

    dialogRef.afterClosed().subscribe(() => {
      this.list();
    });
  }

  edit(data: IHolding): void {
    const dialogRef = this.dialog.open(HoldingEntryComponent, {
      width: "350px",
      data: data
    });

    dialogRef.afterClosed().subscribe(() => {
      this.list();
    });
  }

  delete(data: IHolding): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.holding") + " " + data.Title
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(() => {
      // if (result) {
      //   this.holdingService.delete(data.HoldingGuid).subscribe(
      //     res => {
      //       this.dataSource.data.splice(
      //         this.dataSource.data.findIndex(d => d === data),
      //         1
      //       );
      //     },
      //     err => {
      //       this.errorService.recordHasBennUsed(err);
      //     }
      //   );
      // }
    });
  }
}
